import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Splash from '@/components/Splash.vue'
import Content from '@/components/Content.vue'
import Header from '@/components/Header.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    _createVNode(Splash),
    _createVNode(Content)
  ], 64))
}
}

})